import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Button } from '@Components/common';
import styles from './CharityAddressDetails.module.scss';
import { CharityAddressData } from '@Types/CharityData';

interface CharityAddressDetailsProps {
  // Charity data to display.
  charityAddressData: CharityAddressData;
  // Optional props to override the default button text and behaviour when the button is clicked.
  onUseAddress?: () => void;
  useAddressButtonText?: string;
}

export const CharityAddressDetails = ({
  charityAddressData,
  onUseAddress,
  useAddressButtonText,
}: CharityAddressDetailsProps) => {
  const { t } = useTranslation('account');

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="subtitle2" className={styles.header}>
          {t('tabs.organization.charity_address_details.registered_address_header')}
        </Typography>
        <Typography variant="body2">
          <strong>{charityAddressData.charity_name}</strong>
          <br />
          {charityAddressData.address_line_1 && charityAddressData.address_line_1}
          {charityAddressData.address_line_2 && (
            <>
              <br />
              {charityAddressData.address_line_2}
            </>
          )}
          {charityAddressData.address_line_3 && (
            <>
              <br />
              {charityAddressData.address_line_3}
            </>
          )}
          {(charityAddressData.city || charityAddressData.postcode) && (
            <>
              <br />
              {[charityAddressData.city, charityAddressData.postcode].filter(Boolean).join(', ')}
            </>
          )}
        </Typography>
      </div>

      {onUseAddress && (
        <div className={styles.buttonContainer}>
          <Button buttonType="secondary" size="small" onClick={onUseAddress}>
            {useAddressButtonText ||
              t('tabs.organization.charity_address_details.use_this_address')}
          </Button>
        </div>
      )}
    </div>
  );
};
